export class CustomResponse { 
    status: boolean;
    data: any;
    constructor(){
        this.status = false;
        this.data = null;
    }
}